import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_arrow-pointer-left",
  "use": "svg_arrow-pointer-left-usage",
  "viewBox": "0 0 16 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 12\" id=\"svg_arrow-pointer-left\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m3.83 7 3.59 3.59L6 12 0 6l6-6 1.41 1.41L3.83 5H16v2H3.83z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol